import React, { useMemo } from 'react';
import { Form, FormikConfig } from 'formik';
import * as Yup from 'yup';

import { Button, FormContextProvider, Input, InputField } from '../../';
import { AuthHeader } from '../auth-header';

export type ForgotPasswordFormValues = {
  email: string;
};

export type ForgotPasswordFormProps = {
  isPending?: boolean;
  onChange?: () => void;
  onSubmit: FormikConfig<ForgotPasswordFormValues>['onSubmit'];
  onBackButton: () => void;
};

export const ForgotPasswordForm = ({
  isPending,
  onChange,
  onSubmit,
  onBackButton,
}: ForgotPasswordFormProps) => {
  const validationSchema = useMemo(
    () =>
      Yup.object().shape({
        email: Yup.string().email().required().label('Email'),
      }),
    []
  );

  return (
    <FormContextProvider<ForgotPasswordFormValues>
      initialValues={{ email: '' }}
      validationSchema={validationSchema}
      onChange={onChange}
      onSubmit={onSubmit}
    >
      <Form>
        <AuthHeader
          heading={'Forgot your password?'}
          helpText={
            'Enter your email below and we will send an sms message to reset your password.'
          }
        />
        <InputField name="email" showRequiredIndicator={false}>
          {(field) => <Input type="email" autoComplete="username" {...field} />}
        </InputField>
        <div className="flex justify-end mt-8 space-x-2">
          <Button variant="outline" onClick={onBackButton}>
            Back to login
          </Button>
          <Button
            type="submit"
            pendingText={'Reset my password'}
            isPending={isPending}
          >
            {'Reset my password'}
          </Button>
        </div>
      </Form>
    </FormContextProvider>
  );
};
